import { FeedbackSummaryActionType } from '@modules/oracle/feedbackSummaryStore/feedbackSummaryActionType';
import { feedbackSummaryInitialState } from '@modules/oracle/feedbackSummaryStore/feedbackSummaryInitialState';
import { FeedbackSummaryAction, FeedbackSummaryState } from './types';

export const feedbackSummaryReducer = (
  state: FeedbackSummaryState,
  action: FeedbackSummaryAction,
): FeedbackSummaryState => {
  switch (action.type) {
    case FeedbackSummaryActionType.SET_DATA: {
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    }

    case FeedbackSummaryActionType.SET_VISUAL: {
      return {
        ...state,
        visual: {
          ...state.visual,
          ...action.payload,
        },
      };
    }

    case FeedbackSummaryActionType.RESET: {
      return feedbackSummaryInitialState;
    }

    default:
      return state;
  }
};
